import { Season } from 'src/app/core/domain/season.enum';
import { WritablePart } from 'src/app/core/utils/type-helper';
import { MapElement } from 'src/app/maps/domain/masterdata/map-element.model';
import { MapPosition } from 'src/app/maps/domain/masterdata/map-position.model';
import { SisMapAssetCategory } from 'src/app/maps/domain/masterdata/sismap-asset-category.enum';
import { AssetStatus } from '../livedata/status.enum';
import { AssetSubStatus } from '../livedata/substatus.enum';

export class CustomIcon implements MapElement {
  static readonly defaultColor: string = 'white';
  static readonly empty: CustomIcon = new CustomIcon({ guid: null });

  readonly category = SisMapAssetCategory.CustomIcon;

  guid: string;
  season: Season;
  name: string;
  type: string;
  disallowHighlight: boolean;
  disallowPopUp: boolean;
  iconPositions: MapPosition[];
  iconWidth: number;
  iconHeight: number;
  iconSvgBlobName?: string;

  url: string;

  label?: string;
  status?: AssetStatus;
  subStatus?: AssetSubStatus;
  isCategorySki: boolean;
  isGrey: boolean;
  path?: string;
  pathDashArray?: string;
  pathWeight?: number;
  pathColor?: string;
  pathBackgroundColor?: string;
  defaultPathWeight: number;
  defaultPathColor: string;
  iconAlwaysOnTop?: boolean;
  iconDisableBaseZoom?: boolean;
  iconImageName?: string;
  iconHtml?: string;
  iconUseStatus?: boolean;
  iconUseMeteoData?: boolean;
  newlyAdded?: boolean;

  constructor(init?: Partial<WritablePart<CustomIcon>>) {
    Object.assign(this, init);
  }
}
